import React from "react";

import { getProgress } from "../../../../ProgressBarView/util/getProgress";
import { useProgressBarContext } from "../../../context/ProgressBarContext";
import { Bar } from "../components/Bar";
import { CartText } from "../components/CartText";
import { Container } from "../components/Container";

export const ProgressBar3 = () => {
  const { state, device } = useProgressBarContext();
  const { swapTextPositions } = device.widget.styles.layout;

  const getWeight = (_index: number) => {
    return 1 / state.breakpoints.length;
  };
  const progress = getProgress(state, getWeight);

  return (
    <Container>
      {!swapTextPositions ? (
        <>
          <Bar progress={progress} />
          <CartText />
        </>
      ) : (
        <>
          <CartText />
          <Bar progress={progress} />
        </>
      )}
    </Container>
  );
};
